import apiClient from './api';
import type { 
  ActivityType, 
  CreateActivityTypeRequest, 
  UpdateActivityTypeRequest 
} from '../types/activityType';

export const activityTypeService = {
  /**
   * Get all activity types for a specific company
   */
  getAllByCompany: async (companyId: number, includeArchived?: boolean): Promise<ActivityType[]> => {
    const response = await apiClient.get<ActivityType[]>('/activity-types', {
      params: { companyId, includeArchived },
    });
    return response.data;
  },

  /**
   * Get a specific activity type by ID
   */
  getById: async (activityTypeId: number): Promise<ActivityType> => {
    const response = await apiClient.get<ActivityType>(`/activity-types/${activityTypeId}`);
    return response.data;
  },

  /**
   * Create a new activity type
   */
  create: async (activityTypeData: CreateActivityTypeRequest): Promise<ActivityType> => {
    const response = await apiClient.post<ActivityType>('/activity-types', activityTypeData);
    return response.data;
  },

  /**
   * Update an existing activity type (only name can be updated)
   */
  update: async (activityTypeId: number, activityTypeData: UpdateActivityTypeRequest): Promise<ActivityType> => {
    const response = await apiClient.put<ActivityType>(`/activity-types/${activityTypeId}`, activityTypeData);
    return response.data;
  },

  /**
   * Delete an activity type (soft delete)
   */
  delete: async (activityTypeId: number): Promise<void> => {
    await apiClient.delete(`/activity-types/${activityTypeId}`);
  },

  /**
   * Restore an archived activity type
   */
  restore: async (activityTypeId: number): Promise<void> => {
    await apiClient.post(`/activity-types/${activityTypeId}/restore`);
  },
};
